import React, {memo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {handelCloseMenuLeft} from "../../../../redux/actions";
import {handelOpenModalLoginAndRegister} from "../../../../redux/actions/modals/modalLoginAndRegister";
// import {handelOpenModalRankGuide} from "../../../../redux/actions/modals/modalRankGuide";
import logoArk from "./../../../../images/ark_logo.jpg";
import {handelOpenModalEditProfile} from "../../../../redux/actions/modals/modalEditProfile";
import {
    actionChangeDataWallet,
    actionChangeLoaderMyWallet,
    handelOpenModalMyWallet
} from "../../../../redux/actions/modals/modalMyWallet";
import {
    actionChangeLoaderMyOrders,
    actionDataMyOrders,
    handelOpenModalMyOrders
} from "../../../../redux/actions/modals/myOrders/modalMyOrders";
import axios from "axios";
import {BASE_URL, USERS_LOGOUT_GET, USERS_ORDERS_HISTORY_POST, USERS_TRANSACTIONS_POST, MY_FOOD_PACKAGE_GET, PUBLIC_URL_SERVER} from "../../../../apis";
import swal from 'sweetalert';
import Swal from 'sweetalert2';
import qs from "querystring";
import {Link} from "react-router-dom";
import {
    FaGift,
    FaPhone,
    FaShoppingBasket,
    FaSignInAlt,
    FaSignOutAlt, FaTicketAlt, FaRecipe,
    FaTimes,
    FaUserEdit,
    FaWallet
} from "react-icons/all";
import {actionLogOutUser} from "../../../../redux/actions/user/user";
import {actionChangeStatusShowModalInvitation} from "../../../../redux/actions/modals/modalInvitation.actions";
import {actionChangeStatusShowModalMyDiscounts} from "../../../../redux/actions/modals/modalMyDiscounts.actions";
import {actionChangeStatusShowModalMyFoodPacks, actionChangeLoaderFoodPacks, actionSetMyFoodPacks} from "../../../../redux/actions/modals/modalMyFoodPacks.actions";
import ic_bronze from "../../../../images/icons/ic_bronze_36.png";
import ic_silver from "../../../../images/icons/ic_silver_36.png";
import ic_gold from "../../../../images/icons/ic_gold_36.png";
import ic_carrot from "../../../../images/icons/ic_carrot_36.png";

const MenuLeft = () => {
    const dispatch = useDispatch();
    const {statusShow} = useSelector(state => state.menu);
    const {token, profile, rank} = useSelector(state => state.user);
    const {fullname} = profile;

    var rank_image = '';
    if(token)
    {
        if(rank.total_score >= 3 && rank.total_score <= 4)
            rank_image = ic_bronze;
        else if(rank.total_score >= 5 && rank.total_score <= 8)
            rank_image = ic_silver;
        else if(rank.total_score >= 9 && rank.total_score <= 15)
            rank_image = ic_gold;
    }
        

    const btnOkSingle = Swal.mixin({
        customClass: {
            confirmButton: 'base-btn-green-border btn btn-success',
        },
        buttonsStyling: false
    });



    const handelCloseMenu = () => {
        dispatch(handelCloseMenuLeft());
    };

    const openModalLoginAndRegister = () => {
        handelCloseMenu();
        dispatch(handelOpenModalLoginAndRegister());
    };

    const openModalEditProfile = () => {
        handelCloseMenu();
        dispatch(handelOpenModalEditProfile());
    };
    const openModalMyWallet = () => {
        handelCloseMenu();
        apiGetListTransactions();
        dispatch(handelOpenModalMyWallet());
    };


    const openModalRankGuide = () => {
        handelCloseMenu();
        // dispatch(handelOpenModalRankGuide());

        
        btnOkSingle.fire({
            html: `<div><div className="row mt-4"><div className="col-12 text-center"><img src=${ic_bronze}  alt={"برنز"} style="margin: 5px; width: 30px;" />برنز: 0 تا 5 سفارش</div></div><div className="row mt-3"><div className="col-12 text-center"><img src=${ic_silver}  alt={"نقره‌ای"} style="margin: 5px; width: 30px;" />نقره‌ای: 6 تا 15 سفارش</div></div><div className="row mt-3"><div className="col-12 text-center"><img src=${ic_gold}  alt={"طلایی"} style="margin: 5px; marginBottom: 10px; width: 30px;" />طلایی: 16 سفارش به بالا</div></div></div>`,
            imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
            imageHeight: 45,
            imageAlt: 'فروت مروت',
            confirmButtonText: "تایید",
        });
    };

    const apiGetListTransactions = () => {
        dispatch(actionChangeLoaderMyWallet(true));
        axios({
            method: 'post',
            url: BASE_URL + USERS_TRANSACTIONS_POST,
            data: qs.stringify({
                offset: 0
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            const {
                status,
                transactions: transactions_api,
                total: total_api,
                total_rows: total_rows_api, 
                carrot
            } = response.data;
            if (status === 'ok') {
                dispatch(actionChangeDataWallet(transactions_api, total_api, total_rows_api, 15, carrot));
                dispatch(actionChangeLoaderMyWallet(false));
            }
        });
    };


    const openModalMyOrders = () => {
        handelCloseMenu();
        apiGetListOrders();
        dispatch(handelOpenModalMyOrders());
    };
    const apiGetListOrders = () => {
        dispatch(actionChangeLoaderMyOrders(true));
        axios({
            method: 'post',
            url: BASE_URL + USERS_ORDERS_HISTORY_POST,
            data: qs.stringify({
                offset: 0
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            const {status, contents: contents_api, total_rows: total_rows_api} = response.data;
            if (status === 'ok') {
                dispatch(actionDataMyOrders(contents_api, total_rows_api, 15));
            }
            dispatch(actionChangeLoaderMyOrders(false));
        });
    };

    const exitUserInSite = () => {

        handelCloseMenu();

        const buttonsOkCancel = Swal.mixin({
            customClass: {
                confirmButton: 'modal-carrot-btn-successbase-btn-green btn btn-success ml-4',
                cancelButton: 'base-btn-green-border btn btn-success',
            },
            buttonsStyling: false
        });
        
        buttonsOkCancel.fire({
            text: "آیا میخواهید از حساب کاربری خود خارج شوید؟",
            imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
            imageHeight: 45,
            imageAlt: 'فروت مروت',
            confirmButtonText: "بله",
            showCancelButton: true,
            cancelButtonText: 'انصراف',
        }).then((result) => {
            if (result.isConfirmed) {
                axios({
                    method: 'get',
                    url: BASE_URL + USERS_LOGOUT_GET,
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': token
                    },
                }).then((response) => {
                    switch (response.data.status) {
                        case 'error':
                            swal({
                                title: "خطا در خروج",
                                text: response.data.message,
                                buttons: {
                                    cancel: "تایید",
                                },
                                icon: "error",
                            });
                            break;
                        case 'ok':
                            dispatch(actionLogOutUser());

                            btnOkSingle.fire({
                                title: "خروج از حساب کاربری",
                                text: 'شما با موفقیت از حساب کاربری خارج شدید.',
                                imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
                                imageHeight: 45,
                                imageAlt: 'فروت مروت',
                                confirmButtonText: "تایید",
                            });
                            break;
                        default:
                            swal({
                                title: "خطا در خروج",
                                text: "لطفا مجددا تلاش کنید.",
                                buttons: {
                                    cancel: "تایید",
                                },
                                icon: "error",
                            });
                    }
                }, () => {
                    swal({
                        title: "خطا در خروج",
                        text: "لطفا مجددا تلاش کنید.",
                        buttons: {
                            cancel: "تایید",
                        },
                        icon: "error",
                    });
                });
            }
        });


                
    };

    const openModalMyDiscount = () => {
        handelCloseMenu();
        dispatch(actionChangeStatusShowModalMyDiscounts(true));
    }

    const openModalMyFoodPacks = () => {
        handelCloseMenu();
        apiGetListMyFoodPacks();
        dispatch(actionChangeStatusShowModalMyFoodPacks(true));
    }

    const apiGetListMyFoodPacks = () => {
        dispatch(actionChangeLoaderFoodPacks(true));
        axios({
            method: 'get',
            url: BASE_URL + MY_FOOD_PACKAGE_GET,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            const {status, food_packs} = response.data;
            if (status === 'ok') {
                dispatch(actionSetMyFoodPacks(food_packs));
            }
            dispatch(actionChangeLoaderFoodPacks(false));
        });
    };

    const openModalInvitation = () => {
        handelCloseMenu();
        dispatch(actionChangeStatusShowModalInvitation(true));
    }
    return (
        <div id={'base-box-menu-left'}>
            <div id={'box-menu-left'} className={statusShow ? 'show-box-menu-left' : ''}>
                <div id={'base-header-box-menu-left'}>
                    <div id={'header-box-menu-left'}>
                        <FaTimes id={'icon-close-header-box-menu-left'}
                                 onClick={handelCloseMenu}/>
                        <img src={'https://fruitmruit.com/icons/fm_logo_ofoghi_new.png'} id={'img-logo-menu-left'}
                             alt="Logo Site"/>

                    </div>
                    <div id={'box-fullname-f-menu-left'}>
                        <span className="text-dark" style={{color: "red !important;"}}>{(fullname !== '' && token) ? fullname : 'کاربر مهمان'}</span>
                        {!!token ? 
                        <>
                        <p style={{fontSize: "small", marginBottom: "0"}}>
                            <span className={"align-middle"} role="button"  onClick={openModalRankGuide}>سطح کاربری:</span>
                            <span className="mx-2 align-middle" role="button"  onClick={openModalRankGuide}>{rank.rank}</span>
                            {rank.rank !== 'معمولی' ?
                            <img src={rank_image}  onClick={openModalRankGuide} alt={rank.rank} width={24} role="button" />
                            : '' }
                        </p>
                        <p style={{fontSize: "small"}}>
                            <span className={"align-middle"} >امتیاز شما: </span>
                            <span className="mx-2 align-middle"  >{profile.carrot_inventory}</span>
                            <img src={ic_carrot} alt={profile.carrot_inventory} width={24} />
                        </p>
                        </>
                        : ''}
                        <div style={{width: "80%", borderTop: "1px solid #eaeaea", marginTop: !token ? "2rem" : ""}}></div>
                    </div>
                </div>
                <div id={'box-list-menu-left'}>
                    <ul id={'list-menu-left'}>
                            
                        {!token ?
                            <li className={'item-menu-left'} onClick={openModalLoginAndRegister}>
                                <span className="pl-4">ورود / ثبت نام</span>
                                <FaSignInAlt className={'base-icons-list-menu-left'}/>
                            </li>
                            : ''}
                        {!!token ?
                            <li className={'item-menu-left'} onClick={openModalEditProfile}>
                                <span className="pl-4">ویرایش پروفایل</span>
                                <FaUserEdit className={'base-icons-list-menu-left'}/>
                            </li>
                            : ''}
                        {!!token ?
                            <li className={'item-menu-left'} onClick={openModalMyOrders}>
                                <span className="pl-4">سفارشات من</span>
                                <FaShoppingBasket className={'base-icons-list-menu-left'}/>
                            </li>
                            : ''}
                        {!!token ?
                            <li className={'item-menu-left'} onClick={openModalMyWallet}>
                                <span className="pl-4">کیف پول من</span>
                                <FaWallet className={'base-icons-list-menu-left'}/>
                            </li>
                            : ''}
                        {!!token ?
                            <li className='item-menu-left' onClick={openModalMyDiscount}>
                                <span className="pl-4">تخفیف های من</span>
                                <FaTicketAlt className={'base-icons-list-menu-left'}/>
                            </li>
                            : ''}
                        {!!token ?
                            <li className='item-menu-left' onClick={openModalMyFoodPacks}>
                                <span className="pl-4">پکیج های غذای من</span>
                                <FaRecipe className={'base-icons-list-menu-left'}/>
                            </li>
                            : ''}
                        {!!token ?
                            <li className={'item-menu-left'} onClick={openModalInvitation}>
                                <span className='text-success pl-4'>دوستت رو دعوت کن</span>
                                <FaGift className={'base-icons-list-menu-left text-success'}/>
                            </li>
                            : ''}
                        {!!token ?
                            <li className={'item-menu-left'} onClick={exitUserInSite}>
                                <span className={'text-danger pl-4'}>خروج</span>
                                <FaSignOutAlt className={'base-icons-list-menu-left'}/>
                            </li>
                            : ''}
                        <li className={'item-menu-left'} onClick={handelCloseMenu} >
                            <Link to={`/more-pages/contact-us`} className={'change-base-link-nav'}>
                                <span className="pl-4">تماس با ما</span>
                                <FaPhone className={'base-icons-list-menu-left'}/>
                            </Link>
                        </li>
                    </ul>
                </div>
                <div id={'base-box-logo-developer-menu-left'} style={{cursor: 'ponter'}}
                     title={'طراحی اپلیکیشن موبایل | طراحی وبسایت'} onClick={(event) => {
                    event.preventDefault();
                    window.open("https://4rk.ir");
                }}>
                    <div id={'box-logo-developer-menu-left'} className="pb-2">
                        <img src={logoArk} alt="logo-ark"/>
                        <span>
                            طراحی توسط گروه برنامه نویسی آرک
                        </span>
                    </div>
                </div>
            </div>
            <div id={'box-shadow-menu-left'} className={statusShow ? 'show-box-shadow-menu-left' : ''}
                 onClick={handelCloseMenu}/>
        </div>
    );
};

export default memo(MenuLeft);
